import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const NewProject = lazy(() => import('../pages/projects/new/page'));
const ProjectDetail = lazy(() => import('../pages/projects/detail/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/projects/new',
    element: <NewProject />,
  },
  {
    path: '/projects/:id',
    element: <ProjectDetail />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
